import { render, staticRenderFns } from "./AdminImporter.vue?vue&type=template&id=451ade30"
import script from "./AdminImporter.vue?vue&type=script&lang=js"
export * from "./AdminImporter.vue?vue&type=script&lang=js"
import style0 from "./AdminImporter.vue?vue&type=style&index=0&id=451ade30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports